require("../../node_modules/jquery-ui/ui/core");
require("../../node_modules/jquery-ui/ui/widget");
require("../../node_modules/jquery-ui/ui/effect");
require("../../node_modules/jquery-ui/ui/widgets/accordion");

module.exports = {
  init: () => {
    $(".accordion").each(function(index, item) {
      var activeState = $(item).hasClass("accordion--open") ? 0 : false;
      $(item).accordion({
        header: ".accordion-header",
        collapsible: true,
        active: activeState,
        heightStyle: "content"
      });
    });

    $(window).resize(function() {
      $(".accordion").accordion("refresh");
    });
  }
};
